import { useTranslation } from "react-i18next";
import { getDescription } from "reedy-data";
import { ButtonCopyTextToClipboard } from "~/components/button/button-copy-text-to-clipboard";
import { useProduct } from "~/contexts/product-context";
import { useBookDescription } from "~/contexts/book-description-context";
import { BasePanel } from "~/components/base-panel";
import { EmptyText } from "~/components/empty/empty-text";
import {
  getKeywordsByType,
  keywordsToText,
} from "~/integrations/firebase/collections";
import { Editor } from "~/pages/product-details/tabs/book-description-tab/components/editor";

export const DatabaseDescription = () => {
  const { t } = useTranslation(["productDetails"]);
  const { product } = useProduct();
  const { selectedDescriptionHash, handleCopyDoneDatabaseBookDescription } =
    useBookDescription();
  const { final } = getKeywordsByType(product);

  const selectedDescription = getDescription(product, selectedDescriptionHash);
  const bookDescription = selectedDescription?.text;

  const keywords = {
    final: keywordsToText(final),
  };

  return (
    <BasePanel
      title={t(
        "productDetails:bookDescription.tabDatabase.databaseBookDescription",
      )}
      isEmpty={!bookDescription}
      emptyComponent={
        <EmptyText
          title={t("productDetails:bookDescription.tabDatabase.empty.header")}
          text={t("productDetails:bookDescription.tabDatabase.empty.message")}
          variant="dark"
        />
      }
      className="h-(--subject-list-container-height)"
      wrapper={false}
      headerAction={
        bookDescription && (
          <ButtonCopyTextToClipboard
            textToCopy={bookDescription}
            tooltipText={t("general:tooltips.copyToClipboard")}
            onDone={handleCopyDoneDatabaseBookDescription}
            buttonText={t("general:buttons.copy")}
          />
        )
      }
      border={false}
    >
      {bookDescription && (
        <Editor
          unescapeHtml
          key={`${product?.id}-${selectedDescriptionHash}`}
          className="h-[calc(100%-48px)]"
          initialValue={bookDescription}
          keywords={keywords}
          disabled
        />
      )}
    </BasePanel>
  );
};
